// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_bLWk_ {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
@keyframes spin_FB656 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.mapResults_jXO9q {
  position: relative;
  overflow: hidden;
  flex: 1;
  width: 100%;
}
.mapResults_jXO9q .controls_YRBex {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  top: 8px;
  right: 8px;
}
.mapResults_jXO9q .controls_YRBex > * {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
}
.mapResults_jXO9q .controls_YRBex .mapStyle_Mis6q,
.mapResults_jXO9q .controls_YRBex .settings_zXKtk,
.mapResults_jXO9q .controls_YRBex .bound_pqb73,
.mapResults_jXO9q .controls_YRBex .loadMore_v2Glo {
  background-color: var(--color-brand1);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: white;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 {
  position: relative;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 > * {
  position: absolute;
  height: 6px;
  width: 6px;
  margin: 0;
  padding: 0;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 .top_SxJtu {
  top: 2px;
  border-top: 1px solid white;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 .bottom_OttmR {
  bottom: 2px;
  border-bottom: 1px solid white;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 .left_BdUsn {
  left: 2px;
  border-left: 1px solid white;
}
.mapResults_jXO9q .controls_YRBex .bound_pqb73 .right_lVEjP {
  right: 2px;
  border-right: 1px solid white;
}
.mapResults_jXO9q .controls_YRBex .loading_RiXNp {
  animation: spin_FB656 2s infinite linear;
}
.mapResults_jXO9q .accessSettings_EOQYl {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0;
  transition: margin-top 1s;
}
.mapResults_jXO9q .accessSettings_EOQYl .setting_F2Pos {
  margin-bottom: 4px;
}
.mapResults_jXO9q .accessSettings_EOQYl .setting_F2Pos label {
  min-width: 50px;
}
.mapResults_jXO9q .accessSettings_EOQYl .setting_F2Pos .input_RZHJP {
  border-radius: 4px;
  padding: 0 10px;
}
.mapResults_jXO9q .hidden_rwJN6 {
  margin-top: -200px;
}
.mapResults_jXO9q .rollover_xL8YU {
  position: absolute;
  bottom: 24px;
  right: 8px;
  max-height: 35%;
  padding: 0;
  overflow: scroll;
  border: 1px solid var(--light-grey);
}
.mapResults_jXO9q .selected_LCXQm {
  position: absolute;
  top: 8px;
  left: 8px;
  max-height: 35%;
  overflow: scroll;
  border: 1px solid var(--light-grey);
}
.mapResults_jXO9q .rollover_xL8YU pre,
.mapResults_jXO9q .selected_LCXQm pre {
  border: none;
  margin: 0;
}
.tableResults_Izqvh .link_iW4wC,
.modal_n0PnA .link_iW4wC {
  color: var(--purple);
  border: none;
  background-color: rgba(0, 0, 0, 0);
  opacity: 0.5;
}
.tableResults_Izqvh .link_iW4wC:hover,
.modal_n0PnA .link_iW4wC:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0);
}
.tableResults_Izqvh {
  display: flex;
  width: 100%;
  margin: 8px 0 0 0;
  flex: 1;
  overflow-x: scroll;
  overflow-y: hidden;
  border: 1px solid var(--lighter-grey);
}
.tableResults_Izqvh .table__a5Z7 {
  width: 100%;
}
.tableResults_Izqvh .placeholder_Lrgly {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tableResults_Izqvh .oddRow_uzRH4 {
  background-color: #F7FAFF;
}
.tableResults_Izqvh .evenRow_k2KTe {
  background-color: white;
}
.tableResults_Izqvh .oddRow_uzRH4:hover,
.tableResults_Izqvh .evenRow_k2KTe:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.tableResults_Izqvh .oddRow_uzRH4 > *,
.tableResults_Izqvh .evenRow_k2KTe > *,
.tableResults_Izqvh .headerRow_rRpWT > *,
.tableResults_Izqvh .oddRow_uzRH4 .tableCell__isjr,
.tableResults_Izqvh .evenRow_k2KTe .tableCell__isjr,
.tableResults_Izqvh .headerRow_rRpWT .tableCell__isjr {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 100%;
  text-transform: none;
  margin: 0;
}
.tableResults_Izqvh .oddRow_uzRH4 :first-child,
.tableResults_Izqvh .evenRow_k2KTe :first-child,
.tableResults_Izqvh .headerRow_rRpWT :first-child {
  margin-left: 0;
}
.tableResults_Izqvh .oddRow_uzRH4,
.tableResults_Izqvh .evenRow_k2KTe {
  transition: background-color 0.2s;
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}
.tableResults_Izqvh .oddRow_uzRH4 > *,
.tableResults_Izqvh .evenRow_k2KTe > * {
  overflow-x: scroll;
  border-right: solid 1px rgba(0, 0, 0, 0.05);
}
.tableResults_Izqvh .headerRow_rRpWT > :first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.25);
}
.tableResults_Izqvh .headerRow_rRpWT > * {
  border-right: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  border-top: 1px solid rgba(0, 0, 0, 0.25);
}
.tableResults_Izqvh .center__B6SB {
  margin: auto;
}
.tableResults_Izqvh .noBlueprint_XwqQ8 {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.historyItemArea_pZyuH {
  align-items: flex-start;
}
.endContainer_b_jvp {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.search_TYqXP {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.header_ZJeeQ {
  display: flex;
}
.flexRight_czkiV {
  margin-left: auto;
}
.perPageDropdown_UEI8_ {
  min-width: 75px;
}
.left_BdUsn {
  height: 100%;
}
.pagination_Vdwh2 {
  margin: auto 0 0 0;
}
.header_ZJeeQ {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid var(--background);
}
.listContainer__49Oq {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  flex: 1;
}
.listContainer__49Oq .list_iV4KK {
  border: 1px solid var(--lighter-grey);
  width: 100% ;
  height: 100%;
}
.content_mzrXp {
  height: 100%;
  padding: 10px 26px 10px 20px;
}
.content_mzrXp .queryEditor_lz_gP {
  border: 1px solid var(--lighter-grey);
}
.left_BdUsn {
  margin-right: auto;
}
.right_lVEjP {
  margin-left: auto;
  align-items: flex-start;
}
.right_lVEjP .jump_nzuL0 {
  text-decoration: underline;
  cursor: pointer;
}
.right_lVEjP .jump_nzuL0:hover {
  color: var(--purple);
}
.icon_KeZw3 {
  background-color: var(--purple);
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  margin-left: 0;
}
.icon_KeZw3 .textTop_tc7F_ {
  vertical-align: text-top;
}
.splitRight_ZWq2W {
  width: 450px;
  height: 100%;
  background: var(--background);
}
.stopTimer_LGbYP i {
  color: var(--red);
}
.deleteTimer_SvcOK i {
  color: var(--grey);
}
.editor_kkznD {
  height: 100%;
}
.filter_lx1Sp {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.center__B6SB {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.center__B6SB .loadMore_v2Glo {
  color: var(--purple);
  margin-right: 10px;
}
.modal_n0PnA {
  overflow-y: scroll;
}
.modal_n0PnA .modalHeader_QbXna {
  display: flex;
  flex-direction: column;
}
.modal_n0PnA .modalHeader_QbXna .close_XM3fa {
  margin-left: auto;
  font-size: 20px;
}
.modal_n0PnA .modalHeader_QbXna .title_fHItf {
  font-size: 18px;
  /*font-family: Montserrat, san-serif;*/
  color: #5737BE;
  font-weight: 500;
  margin-left: 8px;
}
.modal_n0PnA .modalBody_d42ro {
  overflow-y: scroll;
}
.modal_n0PnA .modalBody_d42ro .castDrop_NPsTQ {
  min-width: 150px;
}
.modal_n0PnA .modalBody_d42ro .rootOperator_szHgG {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/editors/historyResults/style.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;;;;EAIE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,wCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;;EAEE,YAAY;EACZ,SAAS;AACX;AACA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,YAAY;AACd;AACA;;EAEE,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,qCAAqC;AACvC;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,SAAS;AACX;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,iCAAiC;EACjC,4CAA4C;AAC9C;AACA;;EAEE,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,yCAAyC;AAC3C;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,OAAO;AACT;AACA;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../../style/theme.css\";\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.mapResults {\n  position: relative;\n  overflow: hidden;\n  flex: 1;\n  width: 100%;\n}\n.mapResults .controls {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  top: 8px;\n  right: 8px;\n}\n.mapResults .controls > * {\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n}\n.mapResults .controls .mapStyle,\n.mapResults .controls .settings,\n.mapResults .controls .bound,\n.mapResults .controls .loadMore {\n  background-color: var(--color-brand1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  color: white;\n}\n.mapResults .controls .bound {\n  position: relative;\n}\n.mapResults .controls .bound > * {\n  position: absolute;\n  height: 6px;\n  width: 6px;\n  margin: 0;\n  padding: 0;\n}\n.mapResults .controls .bound .top {\n  top: 2px;\n  border-top: 1px solid white;\n}\n.mapResults .controls .bound .bottom {\n  bottom: 2px;\n  border-bottom: 1px solid white;\n}\n.mapResults .controls .bound .left {\n  left: 2px;\n  border-left: 1px solid white;\n}\n.mapResults .controls .bound .right {\n  right: 2px;\n  border-right: 1px solid white;\n}\n.mapResults .controls .loading {\n  animation: spin 2s infinite linear;\n}\n.mapResults .accessSettings {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 0;\n  transition: margin-top 1s;\n}\n.mapResults .accessSettings .setting {\n  margin-bottom: 4px;\n}\n.mapResults .accessSettings .setting label {\n  min-width: 50px;\n}\n.mapResults .accessSettings .setting .input {\n  border-radius: 4px;\n  padding: 0 10px;\n}\n.mapResults .hidden {\n  margin-top: -200px;\n}\n.mapResults .rollover {\n  position: absolute;\n  bottom: 24px;\n  right: 8px;\n  max-height: 35%;\n  padding: 0;\n  overflow: scroll;\n  border: 1px solid var(--light-grey);\n}\n.mapResults .selected {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  max-height: 35%;\n  overflow: scroll;\n  border: 1px solid var(--light-grey);\n}\n.mapResults .rollover pre,\n.mapResults .selected pre {\n  border: none;\n  margin: 0;\n}\n.tableResults .link,\n.modal .link {\n  color: var(--purple);\n  border: none;\n  background-color: rgba(0, 0, 0, 0);\n  opacity: 0.5;\n}\n.tableResults .link:hover,\n.modal .link:hover {\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0);\n}\n.tableResults {\n  display: flex;\n  width: 100%;\n  margin: 8px 0 0 0;\n  flex: 1;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  border: 1px solid var(--lighter-grey);\n}\n.tableResults .table {\n  width: 100%;\n}\n.tableResults .placeholder {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tableResults .oddRow {\n  background-color: #F7FAFF;\n}\n.tableResults .evenRow {\n  background-color: white;\n}\n.tableResults .oddRow:hover,\n.tableResults .evenRow:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.tableResults .oddRow > *,\n.tableResults .evenRow > *,\n.tableResults .headerRow > *,\n.tableResults .oddRow .tableCell,\n.tableResults .evenRow .tableCell,\n.tableResults .headerRow .tableCell {\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  height: 100%;\n  text-transform: none;\n  margin: 0;\n}\n.tableResults .oddRow :first-child,\n.tableResults .evenRow :first-child,\n.tableResults .headerRow :first-child {\n  margin-left: 0;\n}\n.tableResults .oddRow,\n.tableResults .evenRow {\n  transition: background-color 0.2s;\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\n}\n.tableResults .oddRow > *,\n.tableResults .evenRow > * {\n  overflow-x: scroll;\n  border-right: solid 1px rgba(0, 0, 0, 0.05);\n}\n.tableResults .headerRow > :first-child {\n  border-left: 1px solid rgba(0, 0, 0, 0.25);\n}\n.tableResults .headerRow > * {\n  border-right: 1px solid rgba(0, 0, 0, 0.25);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n  border-top: 1px solid rgba(0, 0, 0, 0.25);\n}\n.tableResults .center {\n  margin: auto;\n}\n.tableResults .noBlueprint {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.historyItemArea {\n  align-items: flex-start;\n}\n.endContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.search {\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.perPageDropdown {\n  min-width: 75px;\n}\n.left {\n  height: 100%;\n}\n.pagination {\n  margin: auto 0 0 0;\n}\n.header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid var(--background);\n}\n.listContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  flex: 1;\n}\n.listContainer .list {\n  border: 1px solid var(--lighter-grey);\n  width: 100% ;\n  height: 100%;\n}\n.content {\n  height: 100%;\n  padding: 10px 26px 10px 20px;\n}\n.content .queryEditor {\n  border: 1px solid var(--lighter-grey);\n}\n.left {\n  margin-right: auto;\n}\n.right {\n  margin-left: auto;\n  align-items: flex-start;\n}\n.right .jump {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.right .jump:hover {\n  color: var(--purple);\n}\n.icon {\n  background-color: var(--purple);\n  color: white;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 5px;\n  margin-left: 0;\n}\n.icon .textTop {\n  vertical-align: text-top;\n}\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background: var(--background);\n}\n.stopTimer i {\n  color: var(--red);\n}\n.deleteTimer i {\n  color: var(--grey);\n}\n.editor {\n  height: 100%;\n}\n.filter {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.center .loadMore {\n  color: var(--purple);\n  margin-right: 10px;\n}\n.modal {\n  overflow-y: scroll;\n}\n.modal .modalHeader {\n  display: flex;\n  flex-direction: column;\n}\n.modal .modalHeader .close {\n  margin-left: auto;\n  font-size: 20px;\n}\n.modal .modalHeader .title {\n  font-size: 18px;\n  /*font-family: Montserrat, san-serif;*/\n  color: #5737BE;\n  font-weight: 500;\n  margin-left: 8px;\n}\n.modal .modalBody {\n  overflow-y: scroll;\n}\n.modal .modalBody .castDrop {\n  min-width: 150px;\n}\n.modal .modalBody .rootOperator {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_bLWk_`,
	"mapResults": `mapResults_jXO9q`,
	"controls": `controls_YRBex`,
	"mapStyle": `mapStyle_Mis6q`,
	"settings": `settings_zXKtk`,
	"bound": `bound_pqb73`,
	"loadMore": `loadMore_v2Glo`,
	"top": `top_SxJtu`,
	"bottom": `bottom_OttmR`,
	"left": `left_BdUsn`,
	"right": `right_lVEjP`,
	"loading": `loading_RiXNp`,
	"spin": `spin_FB656`,
	"accessSettings": `accessSettings_EOQYl`,
	"setting": `setting_F2Pos`,
	"input": `input_RZHJP`,
	"hidden": `hidden_rwJN6`,
	"rollover": `rollover_xL8YU`,
	"selected": `selected_LCXQm`,
	"tableResults": `tableResults_Izqvh`,
	"link": `link_iW4wC`,
	"modal": `modal_n0PnA`,
	"table": `table__a5Z7`,
	"placeholder": `placeholder_Lrgly`,
	"oddRow": `oddRow_uzRH4`,
	"evenRow": `evenRow_k2KTe`,
	"headerRow": `headerRow_rRpWT`,
	"tableCell": `tableCell__isjr`,
	"center": `center__B6SB`,
	"noBlueprint": `noBlueprint_XwqQ8`,
	"historyItemArea": `historyItemArea_pZyuH`,
	"endContainer": `endContainer_b_jvp`,
	"search": `search_TYqXP`,
	"header": `header_ZJeeQ`,
	"flexRight": `flexRight_czkiV`,
	"perPageDropdown": `perPageDropdown_UEI8_`,
	"pagination": `pagination_Vdwh2`,
	"listContainer": `listContainer__49Oq`,
	"list": `list_iV4KK`,
	"content": `content_mzrXp`,
	"queryEditor": `queryEditor_lz_gP`,
	"jump": `jump_nzuL0`,
	"icon": `icon_KeZw3`,
	"textTop": `textTop_tc7F_`,
	"splitRight": `splitRight_ZWq2W`,
	"stopTimer": `stopTimer_LGbYP`,
	"deleteTimer": `deleteTimer_SvcOK`,
	"editor": `editor_kkznD`,
	"filter": `filter_lx1Sp`,
	"modalHeader": `modalHeader_QbXna`,
	"close": `close_XM3fa`,
	"title": `title_fHItf`,
	"modalBody": `modalBody_d42ro`,
	"castDrop": `castDrop_NPsTQ`,
	"rootOperator": `rootOperator_szHgG`
};
export default ___CSS_LOADER_EXPORT___;
